import { odbHttpClientV3 } from './http'

export async function getPublicCompanyInfo({ companyCode }) {
  try {
    const res = await odbHttpClientV3.get(
      `/full-company-open-data/${companyCode}`,
      {
        params: { apiKey: 'nHcfWZx4BjsF' }
      }
    )
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}
